import React, { useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";

const Form = () => {
  const form = useRef();
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_gwr11le",
        "template_lcvnyzm",
        form.current,
        "uH95AZrspEAPYi09X"
      )
      .then((res) => {
        console.log(res);
        form.current.reset();
      })
      .catch((err) => console.log(err));
  };

  return (
    <form ref={form} onSubmit={handleSubmit} className="w-11/12 mt-20 mx-auto">
      <input
        type="text"
        name="from_name"
        placeholder="Name"
        class="input lg:w-full mb-7 w-full input-ghost"
      />
      <input
        type="email"
        name="from_email"
        placeholder="Email"
        class="input input-ghost w-full lg:w-full"
      />
      <textarea
        type="text"
        name="message"
        placeholder="Type your message here..."
        class="input min-h-[100px]  input-ghost w-full my-7"
      />
      <input
        type="submit"
        value={"Submit"}
        class="btn btn-secondary text-base-100 btn-outline w-full max-w-xs mx-auto "
      />
    </form>
  );
};

export default Form;
